import axios from "axios";

export const checkCoupon = async (coupon: string, type?: string) => {
  try {
    const res = await axios.get(
      process.env.NEXT_PUBLIC_CARDS_API +
        "/api/v1/coupons/" +
        coupon +
        "?type=" +
        type
    );
    return res.data.data.rate;
  } catch (error) {
    return null;
  }
};
